var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('OzBaseButton',{class:[
    'focus-visible:outline-none',

    // Reset user agent styles
    // Don't set px-0 here so we won't have specificity issues
    'py-0',

    // Centralize button content
    'flex',
    'items-center',
    'justify-center',
    'group',

    _vm.sizePreset === _vm.SizePreset.H32px && ['h-8', 'rounded-xl', 'text-body-small', _vm.startIconName ? 'px-2' : 'px-3'],
    _vm.sizePreset === _vm.SizePreset.H40px && [
      'h-10',
      'rounded-2xl',
      'text-body-posts',
      _vm.startIconName ? 'px-5' : 'ps-4 pe-3',
    ],

    _vm.colorScheme && [
      // Disabled
      'disabled:bg-transparent',
      {
        'disabled:text-dark-text-200': _vm.darkMode === false,
        'disabled:text-light-text-200': _vm.darkMode === true,
        'disabled:text-dark-text-200 dark:disabled:text-light-text-200': _vm.darkMode === 'auto',
      },

      // Active
      {
        'hover-hover:active:bg-grape-500': _vm.darkMode === false,
        'hover-hover:active:bg-canary-500': _vm.darkMode === true,
        'hover-hover:active:bg-grape-500 hover-hover:dark:active:bg-canary-500': _vm.darkMode === 'auto',
      },

      {
        'hover-hover:active:text-light-text-100': _vm.darkMode === false,
        'hover-hover:active:text-dark-text-100': _vm.darkMode === true,
        'hover-hover:active:text-light-text-100 hover-hover:dark:active:text-dark-text-100': _vm.darkMode === 'auto',
      },

      // Active styles for mobile devices
      {
        'active:bg-grape-500': _vm.darkMode === false,
        'active:bg-canary-500': _vm.darkMode === true,
        'active:bg-grape-500 dark:active:bg-canary-500': _vm.darkMode === 'auto',
      },

      {
        'active:text-light-text-100': _vm.darkMode === false,
        'active:text-dark-text-100': _vm.darkMode === true,
        'active:text-light-text-100 dark:active:text-dark-text-100': _vm.darkMode === 'auto',
      },
    ],

    _vm.colorScheme === _vm.ColorScheme.Secondary && [
      // Focus ring
      'ring-offset-[1.5px]',
      'focus-visible:ring-[2.5px]',
      {
        'ring-grape-500': _vm.darkMode === false,
        'ring-canary-500': _vm.darkMode === true,
        'ring-grape-500 dark:ring-canary-500': _vm.darkMode === 'auto',
      },
      {
        // Tailwind uses box shadows for focus rings.
        // We'll have to deviate from TW paradigm if we want truly transparent ring-offset color.
        'ring-offset-white': _vm.darkMode === false,
        'ring-offset-grey-900': _vm.darkMode === true,
        'ring-offset-white dark:ring-offset-grey-900': _vm.darkMode === 'auto',
      },

      // Background color
      {
        'bg-button-light': _vm.darkMode === false,
        'bg-button-dark': _vm.darkMode === true,
        'bg-button-light dark:bg-button-dark': _vm.darkMode === 'auto',
      },

      // Background hover color
      !_vm.disabled && {
        'hover-hover:hover:bg-button-hover-light': _vm.darkMode === false,
        'hover-hover:hover:bg-button-hover-dark': _vm.darkMode === true,
        'hover-hover:hover:bg-button-hover-light hover-hover:dark:hover:bg-button-hover-dark': _vm.darkMode === 'auto',
      },

      // Text color
      {
        'text-dark-text-100': _vm.darkMode === false,
        'text-light-text-100': _vm.darkMode === true,
        'text-dark-text-100 dark:text-light-text-100': _vm.darkMode === 'auto',
      },
    ],

    _vm.colorScheme === _vm.ColorScheme.SecondaryClearText && [
      // Focus ring
      'ring-offset-[1.5px]',
      'focus-visible:ring-[2.5px]',
      {
        'ring-grape-500': _vm.darkMode === false,
        'ring-canary-500': _vm.darkMode === true,
        'ring-grape-500 dark:ring-canary-500': _vm.darkMode === 'auto',
      },
      {
        // Tailwind uses box shadows for focus rings.
        // We'll have to deviate from TW paradigm if we want truly transparent ring-offset color.
        'ring-offset-white': _vm.darkMode === false,
        'ring-offset-grey-900': _vm.darkMode === true,
        'ring-offset-white dark:ring-offset-grey-900': _vm.darkMode === 'auto',
      },

      // Background color
      {
        'bg-button-light': _vm.darkMode === false,
        'bg-button-dark': _vm.darkMode === true,
        'bg-button-light dark:bg-button-dark': _vm.darkMode === 'auto',
      },

      // Background hover color
      !_vm.disabled && {
        'hover-hover:hover:bg-button-hover-light': _vm.darkMode === false,
        'hover-hover:hover:bg-button-hover-dark': _vm.darkMode === true,
        'hover-hover:hover:bg-button-hover-light hover-hover:dark:hover:bg-button-hover-dark': _vm.darkMode === 'auto',
      },

      // Text color
      {
        'text-dark-text-200': _vm.darkMode === false,
        'text-light-text-200': _vm.darkMode === true,
        'text-dark-text-200 dark:text-light-text-200': _vm.darkMode === 'auto',
      },
    ],

    _vm.colorScheme === _vm.ColorScheme.SecondaryClear && [
      // Focus ring
      'focus-visible:ring-2',
      {
        'ring-grape-500': _vm.darkMode === false,
        'ring-canary-500': _vm.darkMode === true,
        'ring-grape-500 dark:ring-canary-500': _vm.darkMode === 'auto',
      },

      // Base
      'bg-transparent',
      {
        'text-dark-text-100': _vm.darkMode === false,
        'text-light-text-100': _vm.darkMode === true,
        'text-dark-text-100 dark:text-light-text-100': _vm.darkMode === 'auto',
      },
    ],

    _vm.colorScheme === _vm.ColorScheme.SecondaryClearActive && [
      {
        'bg-overlay-text-bg-light-mode-light-hover': _vm.darkMode === false,
        'bg-overlay-text-bg-light-mode-dark-hover': _vm.darkMode === true,
        'bg-overlay-text-bg-light-mode-light-hover dark:bg-overlay-text-bg-light-mode-dark-hover':
          _vm.darkMode === 'auto',
      },
      {
        'text-dark-text-100': _vm.darkMode === false,
        'text-light-text-100': _vm.darkMode === true,
        'text-dark-text-100 dark:text-light-text-100': _vm.darkMode === 'auto',
      },
    ],
  ],attrs:{"dir":_vm.dir,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[(!!_vm.startIconName)?_c('OzIcon',{staticClass:"me-1.5",attrs:{"name":_vm.startIconName,"size":_vm.sizePreset === _vm.SizePreset.H32px ? 16 : 20}}):_vm._e(),_vm._v(" "),_c('span',{class:[!_vm.disabled && 'me-1.5', _vm.shouldTruncateText && 'truncate']},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),(!_vm.disabled)?_c('OzIcon',{class:[
      {
        'text-dark-text-200': _vm.darkMode === false,
        'text-light-text-200': _vm.darkMode === true,
        'text-dark-text-200 dark:text-light-text-200': _vm.darkMode === 'auto',
      },
      {
        'group-active:text-light-text-200': _vm.darkMode === false,
        'dark:group-active:text-dark-text-200': _vm.darkMode === true,
        'group-active:text-light-text-200 dark:group-active:text-dark-text-200': _vm.darkMode === 'auto',
      },
      {
        'hover-hover:group-active:text-light-text-200': _vm.darkMode === false,
        'hover-hover:dark:group-active:text-dark-text-200': _vm.darkMode === true,
        'hover-hover:group-active:text-light-text-200 hover-hover:dark:group-active:text-dark-text-200':
          _vm.darkMode === 'auto',
      },
    ],attrs:{"name":"disclosure","size":16}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }